import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });

export default function Detail() {
    return (
        <div className={`delta-2-max-detail ${css.d2xDetail}`}>
            <A />
            <Dynamic />
        </div>
    );
}
